module.exports = __webpack_public_path__ + "img/car_shina2_28.2e8e0fc3.jpg";